<script setup lang="ts">
import { AdminDialog, RrButton, RrInput, RrSwitch } from '@xjlv2/admin-layout'

const open = defineModel<boolean>('open', { default: false })
const form = defineModel<{
  appCode: string
  appName: string
  bundleId: string
  packageName: string
  harmonyAppId: string
  enabled: boolean
}>('form', {
  required: true
})

defineProps<{
  saving?: boolean
}>()

const emit = defineEmits<{
  save: []
}>()
</script>

<template>
  <AdminDialog v-model:open="open" title="新建推送应用" width="520px" @cancel="open = false">
    <div class="app-dialog-content">
      <div class="form-row">
        <label class="field-label">应用编码 (AppCode) <span class="req">*</span></label>
        <RrInput v-model:value="form.appCode" placeholder="如: mobile-portal, pengpai" />
        <small class="field-hint">唯一应用标识，支持小写字母、数字及中划线</small>
      </div>
      <div class="form-row">
        <label class="field-label">应用显示名称 <span class="req">*</span></label>
        <RrInput v-model:value="form.appName" placeholder="如: 新聚浪移动端、澎湃客户端" />
      </div>
      <div class="form-row-duo">
        <div class="form-field">
          <label class="field-label">iOS Bundle ID</label>
          <RrInput v-model:value="form.bundleId" placeholder="如: com.xztv.mobile" />
        </div>
        <div class="form-field">
          <label class="field-label">Android Package Name</label>
          <RrInput v-model:value="form.packageName" placeholder="如: com.xztv.mobile.android" />
        </div>
      </div>
      <div class="form-row-duo">
        <div class="form-field">
          <label class="field-label">Harmony App ID</label>
          <RrInput v-model:value="form.harmonyAppId" placeholder="如: com.xztv.mobile.harmony" />
        </div>
        <div class="form-field">
          <label class="field-label">启用状态</label>
          <div class="switch-field-line">
            <RrSwitch v-model:checked="form.enabled" />
            <span class="switch-field-text">{{ form.enabled ? '应用已启用' : '应用已停用' }}</span>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <RrButton @click="open = false">取消</RrButton>
      <RrButton type="primary" :disabled="saving" @click="emit('save')">
        {{ saving ? '保存中...' : '确定创建' }}
      </RrButton>
    </template>
  </AdminDialog>
</template>

<style scoped>
.app-dialog-content {
  display: flex;
  flex-direction: column;
  gap: var(--rr-space-4);
}
.form-row,
.form-field {
  display: flex;
  flex-direction: column;
  gap: var(--rr-space-2);
}
.form-row-duo {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--rr-space-4);
}
.field-label {
  font-size: var(--rr-font-size-sm);
  font-weight: var(--rr-font-weight-medium);
  color: var(--rr-color-text);
}
.field-label .req {
  color: var(--rr-color-danger);
}
.field-hint {
  font-size: var(--rr-font-size-xs);
  color: var(--rr-color-text-muted);
}
.switch-field-line {
  display: flex;
  align-items: center;
  gap: var(--rr-space-2);
  min-height: var(--rr-space-8);
}
.switch-field-text {
  font-size: var(--rr-font-size-sm);
  color: var(--rr-color-text-muted);
}
:deep(.rr-switch) {
  width: auto !important;
  flex-shrink: 0;
  align-self: flex-start;
}
</style>
